/**
 * Limits display of extreme risk scores (>80%) for sensitive UX scenarios.
 * Used in dashboard hero and other high-visibility areas where showing exact
 * percentages above 80% may cause undue alarm.
 *
 * Note: This is separate from limitIndividualRisk (>60% cap) which is used
 * for general individual cancer risk display throughout the app.
 *
 * @param risk - The risk value to limit (number or string)
 * @returns Limited risk value as number or string ('>80%', '<0.1%', or 'N/A')
 */
export function limitExtremeRisk(risk: number | string | undefined): number | string {
  if (risk == null || (typeof risk === 'string' && isNaN(Number(risk)))) return 'N/A';

  const riskNumber = Number(risk);
  if (riskNumber > 80) return '>80%';
  if (riskNumber < 0.1) return '<0.1%';

  return riskNumber;
}
